import IMAGES from "@/public/assets/img";
import { WEB_URL } from "./endpoints";

export const SEODATA={

    ABOUTUS:{
        title:'Credlix | Global Supply Chain Financing Platform for Business',
        url: WEB_URL + '/about-us',
        description:'Learn about us, Credlix, and what makes us tech leading tech-enabled global supply chain finance platform',  
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src   
    },
    ABOUTUS_ES:{
        title:'Credlix | Plataforma global de financiación de la cadena de suministro para empresas',
        url: WEB_URL + '/es/about-us',
        description:'Conozca sobre nosotros, Credlix y lo que nos convierte en una plataforma financiera de cadena de suministro global basada en tecnología líder en tecnología.',  
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src   
    },

    ENTERPRISE:{
        title:'Supply Chain Finance for Anchors: Early Payment | Vendor Finance',
        url: WEB_URL+'/enterprise',
        description:'Give your suppliers an access to working capital through early payments, invoice discounting against their invoices using Credlix tech-enabled supply chain financing platform. Connect with our expert now!', 
            
    },

    EARLYPAYMENT:{
        title:'Credlix for Enterprises: Early Payment Discounting Solution for Suppliers',
        url: WEB_URL+'/enterprise/early-payment-discount',
        description:'Enable working capital loans for suppliers through early payments and invoice discounting to avoid cash flow crunch and increase returns. Consult our supply chain finance expert now!', 
        keyword:'early payment discount'   ,
        
    },

    VENDORFINANCE:{
        title:'Vendor Financing Solution in India | Credlix',
        url: WEB_URL+'/enterprise/vendor-financing-india',
        description:"Get direct access to finance for your suppliers' accounts receivable with Credlix Vendor Financin. Connect with our supply chain expert now for Vendor Financing in India.",  
        keyword:'vendor finance, vendor financing scheme, vendor financing in india '  ,
         
    },
    CHANNELFINANCE:{
        title:'Channel Financing Solution in India | Credlix',
        url: WEB_URL+'/enterprise/channel-financing-india',
        description:'Credlix offers Channel Finance solutions in India to enable early payments to dealers/distributors through funding avenues like NBFCs and financial institutions. Contact our supply chain finance expert now.',     
        keyword:'channel financing, channel financing in india',
       
    },


    PURCHASEORDER:{
        title:'Purchase Order Financing | PO Financing Rates made Affordable- Credlix',
        url: WEB_URL+'/export-factoring/purchase-order-financing',
        description:'Looking for affordable PO financing rates? Credlix offers purchase order financing solutions to help businesses fulfill orders and grow. Contact us today.', 
        keyword: 'purchase order financing, PO finance',  
               
    },


    CAREERS:{
        title:'Credlix | Careers. Are you ready to join us?',
        url: WEB_URL+'/careers',
        
        description:'Join us at Credlix and  grow your career with one of the leading fintech in the industry',          
    },


    CONTACT:{
        title:'Credlix: Contact Us | Get in Touch with our Experts',
        url: WEB_URL+'/contact-us',
        
        description:'Get Started with Credlix and transform your supply chain financing journey. Our financing solution brings efficiency to strengthen your relationships with suppliers, distributors, anchors, exporters, and lenders.',       
    },
    NOT_FOUNDPAGE:{
        title:'404 Page',
        url:WEB_URL+'/404',
        
        description:'Page is not there, please search a valid link'
    },
    DOMESTIC:{
        title:'Invoice Discounting for Smal Scale Industries and Businesses | SMEs - Credlix',
        url:WEB_URL+'/invoice-discounting-for-smes',
        
        description:'Credlix offers invoice discounting solutions for small scale industries and businesses, also known as SMEs, to improve cash flow and unlock working capital.',
        keyword: 'Invoice discounting for small businesses, invoice discounting for smes', 
    },
    PRIVACY:{
        title:'Privacy Policy',
        url:WEB_URL+'/privacy-policy',
        description:'Privacy policy for Credlix use'
    },
    TERMS:{
        title:'Terms and Conditions',
        url:WEB_URL+'/terms-and-conditions',
        description:'Terms and conditions for Credlix use'
    },
    THANKYOU:{
        title:'Thank You for contacting',
        url:WEB_URL+'/thankyou-response',
        description:'Thank You for contacting.'
    },
    HSN:{
        title:'Latest HSN Code & GST Rate Finder',
        url:WEB_URL+'/hsn-code',
        description:'Search HSN codes by product name to get the latest GST rates for the goods or services with our HSN code finder.'

    },

    SHIPMENTCALCULATOR:{
        title:'Online Freight Marketplace & Platform for Shipment Cost Calculation',
        url:WEB_URL+'/shipment-calculator',
        description:'Plan your domestic or international shipment with our online freight platform. Get instant and accurate shipping costs for your next import/export.'
    },

    BLOGLIST:{
        title:'Credlix Blogs',
        url:WEB_URL+'/blogs',
        description:'List of blogs in Credlix',
        keyword:'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company'
    },
    BLOGLISTES:{
        title:'Blogs de Credlix',
        url:WEB_URL+'/es-mx/blogs',
        description:'Lista de blogs en Credlix',
        keyword:'financiación de la cadena de suministro, financiación de la cadena de suministro en la India, cadena de suministro en finanzas, empresa de financiación de la cadena de suministro'
    },

    CATEGORYLIST:{
        title:'Credlix Blogs',
        url:WEB_URL,
        description:'List of blogs in Credlix',
        description1:'Complete knowledge hub on ',
        description2:' Read latest blogs and guides on ',
        keyword:'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company'
    },
    VIDEOSLIST:{
        title:'Credlix Videos',
        url:WEB_URL+'/videos',
        description:'List of videos in Credlix',
        keyword:'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company'
    },
    CASESUDIESLIST:{
        title:'Credlix case studies',
        url:WEB_URL+'/case-studies',
        description:'List of case studies in Credlix',
        keyword:'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company'
    },
    EVENTSLIST:{
        title:'Credlix Events',
        url:WEB_URL+'/events',
        description:'List of events in Credlix',
        keyword:'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company'
    },
    NEWSLIST:{
        title:'Credlix News',
        url:WEB_URL+'/news',
        description:'List of PR articles in Credlix',
        keyword:'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company'
    },
    NEWSLIST_ES:{
        title:'Noticias Credlix',
        url:WEB_URL+'/es/news',
        name:'descripción',
        description:'Lista de artículos de relaciones públicas en Credlix',
        keyword:'financiación de la cadena de suministro, financiación de la cadena de suministro en la India, cadena de suministro en finanzas, empresa de financiación de la cadena de suministro'
    },
    INTEREST_CALC:{
        title: 'Best Interest rate Calculator for Export Financing Trade',
        url: WEB_URL+'/interest-calculator',
        image:IMAGES.calcInterest.socialPostImage,
        description:'We provide the lowest interest rates for your export factoring trade with zero factoring fee. Calculate interest rate and get the best price for invoice financing.',
        keyword: 'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company,lowest interest rates for your export factoring,calculate interest rate',
    },
    INTEREST_CALC_ES:{
        title: 'Calculadora de la Mejor Tasa de Interés para el Financiamiento de Comercio de Exportación',
        url: WEB_URL+'/es/interest-calculator',
        image:IMAGES.calcInterest.socialPostImageMexico,
        description:'Ofrecemos las tasas de interés más bajas para su comercio de factoring de exportación sin tarifa de factoring. Calcule la tasa de interés y obtenga el mejor precio para el financiamiento de facturas.',
        keyword: 'Financiamiento de la cadena de suministro, financiamiento de la cadena de suministro en India, cadena de suministro en finanzas, empresa de financiamiento de la cadena de suministro, las tasas de interés más bajas para su factoring de exportación, calcule la tasa de interés.',
    },
    WEBINAR:{
        title: 'Webinars', 
        url: WEB_URL+'/webinars',
        description:'Credlix Webinars',
        keyword: 'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company',
   
    },
    credlixFinsight:{
        title: 'Credlix Finsights', 
        url: '/credlix-finsight',
        description:'Credlix Finsights',
        keyword: 'For the growth journey of your business',
   
    },
    TERMSHEET:{
        title:'Generate Export Term Sheet | Credlix',
        url:WEB_URL+'/export-factoring/buyer-credit-check',
        description:'Generate your export financing term sheet in 5 minutes and start your factoring journey with Credlix.',
 
    },
    HTS:{
        title:'HTS Code Search – Harmonized Tariff Schedule Lookup by Code or Product',
        url:WEB_URL+'/hts-code',
        description:'Find HTS codes quickly by product name or number. Learn what HTS codes are, how they differ from HS codes, and check import duty rates.'

    },
    Import_Duty:{
        title:'Mexico Import Duty and Tariff Rate Finder',
        url:WEB_URL+'/mexico-import-duty',
        description:'Find Mexico import duties and tariff rates instantly. Search by HS code or product name, and get accurate trade charges for seamless cross-border imports.'
    },
    FinanceGlossary:{
        title:'Trade Finance Glossary | Export Import Terms A to Z',
        url:WEB_URL+'/finance-glossary',
        description:'Learn about trade finance and key export import terms with definitions, examples, and benefits through our financial glossary.'
    },
    GrievanceRedressal:{
        title:'Grievance Redressal Officer for Digital Lending Products | Credlix',
        url:WEB_URL+'/grievance-redressal',
        description:'Find contact details, address, and availability of the Grievance Redressal Officer for digital lending products at Credlix. Reach out to resolve your grievances.'
    },
    // COMPLIANCE:{
    //     title:'Compliance',
    //     url:WEB_URL+'complaince',
    //     
    //     description:'Credlix-complaince'
    // }

    // LEADGEN:{
    //     title:'Credlix: Contact Us | Get in Touch with our Experts',
    //     url: 'https://www.credlix.com/contact',
    //     
    //     description:'Get Started with Credlix and transform your supply chain financing journey. Our financing solution brings efficiency to strengthen your relationships with suppliers, distributors, anchors, exporters, and lenders.',       
    // }
}